import { render, staticRenderFns } from "./ReviewsCard.vue?vue&type=template&id=c215c9d2&"
import script from "./ReviewsCard.vue?vue&type=script&lang=js&"
export * from "./ReviewsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports